import { getBackrsToken } from '../utils/tokenHelpers';

export type UseAuthResult = Readonly<{
  loggedIn: boolean;
}>;

export const useAuth = (): UseAuthResult => {
  const accessToken = getBackrsToken();

  return {
    loggedIn: !!accessToken,
  };
};
